import request from '@/axios';
import website from "@/config/website";

export const loginByUsername = (tenantId, username, password, type, key, code = '', ticket) => request({
  url: '/lebo-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
    'Captcha-Key': key,
    'Captcha-Code': ticket,
  },
  params: {
    tenantId,
    username,
    password,
    grant_type: (website.captchaMode ? "captcha" : "password"),
    scope: "all",
    type,
    ticket,
    code
  }
});

export const refreshToken = (refresh_token, tenantId) => request({
  url: '/lebo-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId
  },
  params: {
    tenantId,
    refresh_token,
    grant_type: "refresh_token",
    scope: "all",
  }
});

export const getButtons = () => request({
  url: '/lebo-system/menu/buttons',
  method: 'get'
});

export const getCaptcha = () => request({
  url: '/lebo-auth/oauth/captcha',
  method: 'get'
});

export const logout = () => request({
  url: '/lebo-auth/oauth/logout',
  method: 'get'
});

export const getUserInfo = () => request({
  url: '/lebo-auth/oauth/user-info',
  method: 'get'
});

export const sendLogs = (list) => request({
  url: '/lebo-auth/oauth/logout',
  method: 'post',
  data: list
});

export const clearCache = (data) => request({
  url: '/lebo-auth/oauth/clear-cache',
  method: 'get',
  params: data
});

// export const refreshCache = () => request({
//   url: '/lebo-auth/oauth/clear-cache?cacheName=lebo:sys',
//   method: 'get',
//   params: data
// })


/** 资源位查询 */
export const getAppResourceConfig = (params) => {
  return request({
    url: `/lebo-desk/endpoint/app-resource/${params}`,
    method: 'get'
  })
}

/** 根据token查询用户信息 */
export const getUserInfoByToken = (params) => {
  return request({
    url: `lebo-auth/getUserInfoByToken?access_token=${params}`,
    method: 'get'
  })
}